import anime from 'animejs';
import { live } from '../data/live'

export let inforoll = {
    rowHeight: 90,
    initialYOffset: 0,
    rowsYOffset: 0,
    rows: [
        "One morning, when **Gregor Samsa** woke from troubled dreams, he found",
        "himself transformed in his bed into a **horrible vermin**. He lay on his",
        "armour-like back, and if he lifted his head a little he could see",
        "his brown belly, slightly **domed** and **divided** by arches into stiff sections.",
    ],
    currentRows: [],
    rowsEl: undefined,
    totalSteps: 0,
    advanceTimeout: 7000,
    advanceInterval: -1,
    currentInforollNumber: 0,
    freezeInforoll: false,
    frozenInforollText: '',

    initVariables: () => {
        inforoll.initialYOffset = -inforoll.rowHeight;
        inforoll.rowsYOffset = inforoll.initialYOffset;
        inforoll.rowsEl = document.getElementById("infobar-rows");
        inforoll.totalSteps = inforoll.rowsEl.children.length + 2;
    },

    createDomElements: () => {
        let rowParent = document.getElementById("infobar-rows");
        rowParent.innerHTML = "";
        if (inforoll.freezeInforoll)
            inforoll.rows = [[inforoll.frozenInforollText]];
        else
            inforoll.rows = inforoll.getRows();

        inforoll.currentRows = inforoll.rows[inforoll.currentInforollNumber] ?? [];
        inforoll.currentRows?.forEach(row => {
            var rowNode = document.createElement("div");
            rowNode.className = 'infobar-row bar-height';
            const rowText = row.replaceAll(/[*][*](.*?)[*][*]/g, '<span class="hl">$1</span>');
            rowNode.innerHTML = rowText;
            rowParent.appendChild(rowNode);
        });
    },

    getRows: () => {
        inforoll.rows = live.getInforollRows()?.split("\n\n").map(block => block.split("\n")) ?? [];
        return inforoll.rows;
    },

    /** Resolved by clearIntervalAndReset() when the block has finished scrolling. */
    finished: undefined,

    /**
     * Scrolls one inforoll block, then resolves. The cycle driver decides what comes
     * next — this used to call overlayRenderer.showDonationGoalProgressBar() directly,
     * which was one half of the import cycle.
     */
    play: () => {
        const done = new Promise((resolve) => { inforoll.finished = resolve; });
        inforoll.start();
        // A frozen bar never advances, so nothing would resolve it. Report done at once;
        // the driver's `haltAfter` is what parks the cycle.
        if (inforoll.freezeInforoll) inforoll.finished();
        return done;
    },

    start: () => {
        inforoll.freezeInforoll = live.getFreezeInforoll();
        inforoll.frozenInforollText = live.getFrozenInforollText();

        inforoll.createDomElements();
        inforoll.initVariables();
        if (!inforoll.freezeInforoll) {
            inforoll.advanceInterval = setInterval(inforoll.advanceNextRow, inforoll.advanceTimeout);
        } else {
            inforoll.rowsEl.classList.add("frozen");
        }
        inforoll.rowsEl.style.opacity = 1;
        inforoll.advanceNextRow();
    },

    advanceNextRow: () => {
        anime({
            targets: inforoll.rowsEl,
            translateY: inforoll.rowsYOffset,
            easing: 'easeInOutQuad',
            duration: 250,
        });
        inforoll.rowsYOffset -= inforoll.rowHeight;
        if (inforoll.freezeInforoll)
            return;

        if (inforoll.rowsYOffset <= -inforoll.rowHeight * (inforoll.totalSteps)) {
            inforoll.currentInforollNumber++;
            if (inforoll.currentInforollNumber >= inforoll.rows.length) {
                inforoll.currentInforollNumber = 0;
            }
            // console.log("Advancing inforoll", inforoll.currentInforollNumber);
            setTimeout(inforoll.clearIntervalAndReset, 250);
            inforoll.rowsEl.style.opacity = 0;
        }
    },

    clearIntervalAndReset: () => {
        clearInterval(inforoll.advanceInterval);
        anime({
            targets: inforoll.rowsEl,
            translateY: 0,
            easing: 'steps(1)'
        });
        inforoll.finished?.();
    }
}

window.inforoll = inforoll;
window.infoBar = inforoll; // deprecated alias